import { LLM } from '@/types'
import i18next from 'i18next'

import { CATEGORIES } from '../categories'

const OPENAI_PLATORM_LINK = 'https://platform.openai.com/docs/overview'
const ANTHROPIC_PLATFORM_LINK = 'https://docs.anthropic.com/claude/reference/getting-started-with-the-api'

// OpenAI Models (UPDATED 1/25/24) -----------------------------

// GPT-4 Turbo (UPDATED 1/25/24)
const Losi_Omega: LLM = {
  modelId: 'losi-omega',
  modelName: 'Losi Max',
  provider: 'marshmallow',
  hostedId: 'losi-omega',
  tier: 'pro',
  description: () =>
    'Powered by Claude Sonnet 5 for advanced reasoning, coding, and agentic work',
  platformLink: ANTHROPIC_PLATFORM_LINK,
  imageInput: true,
  tools: true,
  badge: 'Auto',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 1.5,
    outputCost: 3.5
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.TRANSLATION,
    CATEGORIES.TECHNOLOGY_WEB
  ]
}

const Losi_Mini: LLM = {
  modelId: 'losi-mini',
  modelName: 'Losi Mini',
  provider: 'marshmallow',
  hostedId: 'losi-mini',
  tier: 'free', // Free for everyone
  description: () => 'Fast, cost-efficient Losi powered by Claude Haiku 4.5 for everyday tasks',
  platformLink: ANTHROPIC_PLATFORM_LINK,
  imageInput: true,
  tools: true,
  badge: 'Auto',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.5,
    outputCost: 1.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.TRANSLATION
  ]
}

const Losi_AI: LLM = {
  modelId: 'losi-flash',
  modelName: 'Losi AI',
  provider: 'marshmallow',
  hostedId: 'losi-flash',
  description: () =>
    'Advanced Losi powered by non-reasoning models for faster, more empathic and creative responses with enhanced capabilities',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  tags: ['creative', 'fast', 'enhanced'],
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2.0,
    outputCost: 8.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.TRANSLATION,
    CATEGORIES.TECHNOLOGY_WEB,
    CATEGORIES.REASONING
  ]
}

export const MARSHMALLOW_LLM_LIST: LLM[] = [Losi_Omega, Losi_Mini]
